import { Modal } from "../../Modal/Modal"
import { Button } from "../../Button/Button"
import * as React from "react"

type Props = {
    onClose: () => void
}
export const UnsupportedBrowserModal = (props: Props) => {
    return (
        <Modal isVisible={true} onClose={props.onClose} size="small">
            <div className={classes.wrap}>
                <div className={classes.title}>Unsupported browser</div>
                <div className={classes.label}>
                    <p>Your browser does not support processing of images.</p>
                    <p>
                        Please try again with different browser, or disable fingerprinting protection in your browser
                        settings
                    </p>
                </div>
                <div className={classes.btnsWrap1}>
                    <Button className={classes.actionBtn} onClick={props.onClose}>
                        Close
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

const classes = {
    wrap: "-m-1",
    title: "mb-2.5 mt-2 text-22 font-bold",
    label: "mb-5 text-14",
    cropEl: "mb-3 border border-gray-200 bg-white",
    btnsWrap1: "flex justify-end",
    actionBtn: "flex-1",
    warnMsg: "mb-4 -mt-2 rounded-lg border border-orange-500/70 bg-orange-500/10 py-2 px-3",
}
